export const defaultPreChatSurveyLocalizedTexts = {
  PRECHAT_REQUIRED_FIELD_MISSING_MESSAGE: "{0} field is required"
};